import dayjs from 'dayjs';

export function formatDateWithUTC(dateTime: string | null | undefined, format = 'DD/MM/YYYY') {
  if (!dateTime) {
    return '';
  }
  return dayjs(dateTime).format(format);
}
